<template>
  <div ref="paymentpage" id="paymentpage">
                                            <ValidationObserver v-slot="{ handleSubmit}">

    <div id="flight-result-wrapper">
      <div class="passenger-info-page">
        <div class="d-flex">
          <div class="left">
            <div class="passenger-card-wrapper">
              
              <cSelFlightInfo
                :isPaxPage="true"
                v-if="sHotelSearchObj && sHotelSearchObj.trip!=3 && selFlight && selFlight.ob && selFlight.ob.obFlight.length>0 
                || selFlight && selFlight.ib&& selFlight.ib.ibFlight.length>0"
                :selflightObj="selFlight"
              />

              <cMLSelFlightInfo :isPaxPage="true"
                v-if="sHotelSearchObj && sHotelSearchObj.trip==3 && selFlight&&selFlight.length!=0"
                :selectedflightList="selFlight"
                  />
            </div>

                      <cBookingPayList @getSelPayment="getSelectedPay"  :selectedPayObject="selectedPayType" @getPaySettingsList="getPaySettList" :selPayResDetails="selPayResDetails" @getSelPaySubDetail="getSelPaySubDet"/>
            <CCard  class="instration-card">
              <CCardBody>
        <span>
          {{ $t('paymentPage.agreeWid')}}
          <a class="active-link"
             @click="onToggleTCModal"
          >{{ $t('paymentPage.tcHeading')}}</a>
          {{ $t('paymentPage.byProceedPay')}}.
        </span>
                <br />
                <span>{{ $t('paymentPage.note')}}</span>
              </CCardBody>
              
            </CCard>
           <!-- <div class="payment-wrapper">
              <div class="head-cus">
                <p>{{ $t('paymentPage.paymentSelHeading')}}</p>
              </div>

              <div
                class="body"
                v-for="paymentType in lsPaymentSettings"
                :key="paymentType.groupId"
                v-bind:class="[{ 'option active': selectedPayType.groupId==paymentType.groupId?true:false }]"
              >
                <div class="details">
                  <div class="title m-0">
                    <div class="form-row form-inline">
                      <div role="group" class="custom-control custom-radio">
                        <input
                          id="F0"
                          type="radio"
                          value="[object Object]"
                          :checked="selectedPayType.groupId==paymentType.groupId?true:false"
                          class="custom-control-input"
                        />
                        <label for="c" class="custom-control-label"></label>
                      </div>
                      {{paymentType.groupName}}
                    </div>
                  </div>
                  <div class="dec">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Necessitatibus,
                      vitae.
                    </p>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
                  </div>
                </div>
                <div
                  class="options-wrap"
                  v-for="payment in paymentType.paymentSettings"
                  :key="payment.paymentsettingsid"
                >
                  <div class="row w-100">
                    <div @click="onSelectPayment(payment)" class="col-md-3">
                      <div
                        v-bind:class="[{ 'option active': selectedPayType.paymentsettingsid==payment.paymentsettingsid?true:false }]"
                      >
                        <img :src="payment.logourl" alt />
                      </div>
                      {{payment.providername}}
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>

<!--          old booking summary-->
<!--          <div class="right">-->
<!--            <div class="search-modify-wrap">-->
<!--              <div class="title packages mt-0px mb-0">-->
<!--                <div class="main" style="margin-bottom: 11px;">{{ $t('paymentPage.bookingSummary')}}</div>-->
<!--                &lt;!&ndash; <span><img src="@imgPath/img/svg/icons/cross-radius.svg" alt=""-->
<!--                width="20px"></span>&ndash;&gt;-->
<!--              </div>-->
<!--              <div class="total-price-wrap">-->
<!--                <cPerPaxPriceInfo-->
<!--                  v-if="selFlight&&selFlight.ob&&isPayTypeChanged"-->
<!--                  :selflightObj="selFlight"-->
<!--                  :isPayment="selectedPayType.paymentsettingsid?true:false"-->
<!--                />-->
<!--                <div class="total-wrap">-->
<!--                  <cTotalPriceInfo-->
<!--                    v-if="selFlight&&selFlight.ob&&isPayTypeChanged"-->
<!--                    :isFooter="false"-->
<!--                    :selflightObj="selFlight"-->
<!--                  />-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          old booking summary end-->


          <div class="right mob-m-auto">
            <div class="search-modify-wrap booking-sum-right-stick">

              <div class="total-price-wrap" >
               <!--              <div class="total-price-wrap"  :class="{'smooth441ani': isSummaryAnim}">-->
                <div class="title packages mt-0px mb-0">
                  <div class="main" style="margin-bottom: 11px;">{{ $t('paymentPage.bookingSummary')}}</div>
                  <span><img src="@imgPath/img/svg/icons/cross-radius.svg" alt=""
                             width="20px"></span></div>
                             
                <div @click="isSummaryAnim =!isSummaryAnim">
                
                  <cPerPaxPriceInfo v-if="sHotelSearchObj &&
                   sHotelSearchObj.trip!=3 && 
                  selFlight&&selFlight.ob && isPayTypeChanged" 
                  :selflightObj="selFlight" 
                  :isPayment="selectedPayType.paymentsettingsid?true:false"
                  />

                  <!-- {{'ISPAYMENT'+selectedPayType.paymentsettingsid}} -->
                  <!-- <div v-for="(selflightObj, index) in selFlight" :key="'p'+index"> -->
                      <cMLPerPaxPriceInfo v-if="sHotelSearchObj && 
                      sHotelSearchObj.trip==3 && 
                       selFlight && selFlight.length!=0 && isPayTypeChanged" 
                       :pricingUnit="selFlight" 
                       :isPayment="selectedPayType.paymentsettingsid?true:false"
                      />
                      <!-- </div> -->
                </div>
                <div class="total-wrap">

                  <cTotalPriceInfo v-if="sHotelSearchObj && sHotelSearchObj.trip!=3
                   && selFlight && selFlight.ob && isPayTypeChanged 
                  &&selFlight.ob.clientPricing && selFlight.ob.clientPricing.isTotal"
                   :isFooter="false" :selflightObj="selFlight"/>

                   <cMLTotalPriceInfo v-if="sHotelSearchObj && sHotelSearchObj.trip==3 && 
                   selFlight && selFlight.length!=0 && isPayTypeChanged" :isFooter="false" 
                       :lsPricingUnits="selFlight"/>
                </div>
              </div>


            </div>

          </div>


        </div>
      </div>
    </div>

    <cAlertModal  v-if="isBookFailAlert"
      :show="isBookFailAlert"
      :status="0"
      :buttonList="getBookFailModalBtns()"
      :desc="alertValue"
    ></cAlertModal>
    <cAlertModal v-if="isAlertWhileNav"
      :buttonList="[
      { name:$t('paymentPage.okButton'),func: navToResultPage,color: 'danger'},]"
      :show="isAlertWhileNav"
      :status="0"
      :desc="alertValue"
    ></cAlertModal>

    <cAlertModal v-if="isSelPaymentAlert"
      :buttonList="[
      { name:$t('paymentPage.selPayAlertOkBtn'),func: onHideSelPaymentAlert,color: 'danger'},]"
      :show="isSelPaymentAlert"
      :status="0"
      :desc="$t('paymentPage.selectPayAlert')"
    ></cAlertModal>

    <cTC v-if="isTCshow"
      :buttonList="[
                {name:$t('paymentPage.okButton'),func:onToggleTCModal,color:'success'},]"
      :status="1"
      :show="isTCshow"
      :desc=" $t('paymentPage.TC')"
      :heading=" $t('paymentPage.tcHeading')"
      :externalLink="tcLink" :closeOnBackdrop="true"
       @updateShow="onToggleTCModal"
    ></cTC>
   
    <cFlightFooter v-if="sHotelSearchObj.trip!=3 &&isPaySubmitted&&!isHideFooter"
    :isPayment="selectedPayType.paymentsettingsid?true:false"
      :isSticky="false"
      :isFlightSel="selFlight && selFlight.ob!=null || selFlight && selFlight.ib!=null"
      :buttonName="(selectedPayType.paymentsettingsid==60||selectedPayType.paymentsettingsid==58||selectedPayType.paymentsettingsid==47||selectedPayType.paymentsettingsid==5
      ||selectedPayType.paymentsettingsid==6)?$t('paymentPage.proceedBtn'):$t('paymentPage.payNowBtn')"
      :selFlight="selFlight"
      :type="true"
      @onContinue="handleSubmit(onSubmitPayment)" :isDisable="!(selectedPayType.paymentsettingsid &&
          selectedPayType.groupId)" :tooltipText="$t('paymentPage.toolTipBtnText')"
    />

    <cMLFlightFooter v-if="sHotelSearchObj.trip==3 && isPaySubmitted&&!isHideFooter"
    :isPayment="selectedPayType.paymentsettingsid?true:false"
      :isSticky="false"
      :isFlightSel="selFlight && selFlight.length!=0"
      :buttonName="(selectedPayType.paymentsettingsid==60||selectedPayType.paymentsettingsid==58||selectedPayType.paymentsettingsid==47||selectedPayType.paymentsettingsid==5||selectedPayType.paymentsettingsid==6)?$t('paymentPage.proceedBtn'):$t('paymentPage.payNowBtn')"
      :selFlight="selFlight"
      :type="true"
      @onContinue="handleSubmit(onSubmitPayment)"
      :isDisable="!(selectedPayType.paymentsettingsid &&
          selectedPayType.groupId)" :tooltipText="$t('paymentPage.toolTipBtnText')"
    />
                                    </ValidationObserver>

  </div>
</template>
<script>

import cMLSelFlightInfo from "../../../../components/MLCity/pricing/cMLSelFlightInfo";
    import cMLTotalPriceInfo from "../../../../components/MLCity/pricing/cMLTotalPriceInfo";
    import cMLPerPaxPriceInfo from "../../../../components/MLCity/pricing/cMLPerPaxPriceInfo";
    import cMLFlightFooter from "../../../../components/MLCity/footer/cMLFlightFooter";
import cBookingPayList from "../../../../components/booking/hotel/payment/cBookingPayList";

// import cPaymentList from "../../../../components/payment/cPaymentList";

import { formatDate,getDiffBtwDates} from "../../../../util/date/dateFunctions";
import cAlertModal from "../../../../components/form/cAlertModal";

import apiCreateBookingForHotel from "../../../../services/apiCreateBookingForHotel.js";

import router, { navigate, goBack, updateDataEdited } from "../../../../router/index";

// import apiGetPaymentSettings from "../../../../services/apiGetPaymentSettings";
import apiSelectPaymentForHotel from "../../../../services/apiSelectPaymentForHotel";

import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import {
  handleJWT,
  getErrorAlertValue,
  cloneData,
  addClassToBody,
  removeClassBody,
  handleSessionExist,
  navigateByHostUrl,
  cloneDeep,
  
} from "../../../../util/util";

import cFlightFooter from "../../../../components/result/cFlightFooter";

import { mapGetters, mapActions } from "vuex";
import cPerPaxPriceInfo from "../../../../components/result/cPerPaxPriceInfo";
import cTotalPriceInfo from "../../../../components/result/cTotalPriceInfo";
import cSelFlightInfo from "../../../../components/result/cSelFlightInfo";
import cTC from "../../../../components/modal/cTC";
    import {ValidationObserver, localize, Validator} from "vee-validate";

import {
  COMPONENT_NAME,
  PATHNAME,
  ROUTER_PARAM,
  PAX,
  TOAST_TYPE,
  PROCEED_TO_TYPE,
  PAYMENT_FOR,
  GENDER,
  BOUND_TYPE,DATE_TIME_FORMAT,
  TRIP
} from "../../../../util/constants";
import Logger from "../../../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../config/API_DATA";
import BaseConfiguration from "../../../../config/base";

export default {
  name:COMPONENT_NAME.HOTEL_PAYMENT_PAGE,
  components: {
    cTC,
    cSelFlightInfo,
    cPerPaxPriceInfo,
    cTotalPriceInfo,
    cFlightFooter,
    cAlertModal,
    cBookingPayList,
    cMLSelFlightInfo,
            cMLTotalPriceInfo,
            cMLPerPaxPriceInfo,
            cMLFlightFooter,
            ValidationObserver
  },
  data: () => ({
    // paymentFor:PAYMENT_FOR.BOOKING_FLOW,
    isSelPaymentAlert: false, /// show alert to select payment type
    isAlertWhileNav: false, //get confirmation before navigating to results page
    // bookingResponse: null, //createBookingRes
   sHotelSearchObj:null,
    alertValue: null,
    isBookFailAlert: false,

    selFlight: null,
    isPayTypeChanged: true,
    selectedPayType: {
      paymentsettingsid: null,
      groupId: null,
      providertype:null
    },
    tcLink: BaseConfiguration.paymentTCLink,
    isTCshow: false,
    isSummaryAnim:false,
    isPaySubmitted:true,
    isHideFooter:false,
    selPayResDetails:null,
    selPaySubDetail:null,
    isNeedToShowAlertModal:true


  }),
  computed: {
      ...mapGetters("sHotelSearch", {
      sSearchObj: "GET_HOTEL_SEARCH_OBJ"
    }),

    ...mapGetters("sMLResult", {
      selectedMLFlight: "GET_SEL_FLI_FRM_PRIC",
      searchMLPricingReq: "GET_SEARCH_PRICING_REQ"
    }),
    ...mapGetters("sResult", {
      selectedFlight: "GET_SEL_FLI_FRM_PRIC",
      searchPricingReq: "GET_SEARCH_PRICING_REQ",
     GET_CURRENCY: "GET_CURRENCY"
    }),
    ...mapGetters("sPaymentPage", {
      sSelectedPayTypeObj: "GET_SEL_PAY_TYPE_OBJ"
    }),
    ...mapGetters("sGuestPage", {
      sPaxList: "GET_PAX_LIST"
    }),
    ...mapGetters("sAgtLogin", {
      sSignInRes: "GET_SIGNIN_RES"
    }),
      ...mapGetters("sCMultiCitySearch", {
      GET_ML_SEARCH_OBJ: "GET_ML_SEARCH_OBJ",

    }),
    
  },

  mounted() {
    this.$root.$emit("toggle-sidebar-minimize");    
  },

  async created() {
    try {
      this.$root.$emit("toggle-sidebar-minimize");
        let that = this;
            setTimeout(function(){
                that.scrollToElement("paymentpage");
            },100)
      // if(this.sSearchObj&&this.sSearchObj.trip!=TRIP.MULTI_CITY){
            this.sHotelSearchObj=this.sSearchObj;
            
            // }else{
            //      this.sHotelSearchObj=this.GET_ML_SEARCH_OBJ;
                  
            // }
// console.error(this.sSelectedPayTypeObj);
      // if(this.selectedFlight) {
      //   this.selFlight = this.selectedFlight;
      // }else if(this.selectedMLFlight){
      //   this.selFlight = cloneDeep(this.selectedMLFlight);
      // }
      updateDataEdited(true);
      // else
      //   navigate(PATHNAME.FLIGHTSEARCH); //need to handle
      //  this.selectedPayType=this.sSelectedPayTypeObj;

      // this.lsPaymentSettings = await this.getPaySettingsRes();

      // if (this.sSelectedPayTypeObj) {
      //   this.selectedPayType = this.sSelectedPayTypeObj;

      //   let selectedPayRes = await this.getSelectPayment(
      //     this.selectedPayType.paymentsettingsid
      //   );

      //   let formattedSelFlight = this.formatCalculatedFee(selectedPayRes);

      //   if (formattedSelFlight) {
      //     this.selFlight = formattedSelFlight;
      //   }
      // }
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.PAYMENTPAGE,
        "error while created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },

  methods: {
    ...mapActions("sPaymentPage", {
      SET_PAY_TYPE_OBJ: "SET_PAY_TYPE_OBJ",
      SET_CREATE_BOOKING_RES:"SET_CREATE_BOOKING_RES",
            SET_CREATE_BOOKING_REQ:"SET_CREATE_BOOKING_REQ"

      
    }),
    ...mapActions("sResult", {
      
                  SET_SELFLIGHT_FOR_FOOTER:"SET_SELFLIGHT_FOR_FOOTER",
                  CLEAR_RESULT_STORE:"CLEAR_RESULT_STORE"

    }),
    ...mapActions("sMLResult", ["CLEAR_ML_RESULT_STORE"]),
 ///scroll into view
            scrollToElement(pRef) {
                var el = null;
                if(pRef == 'paymentpage') { 
                     el = this.$refs.paymentpage;
                }
                
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth' });
                }
            },
getPaySettList(pPaySettingsLs) {
    try {
      if(BaseConfiguration.isDebug) console.log("getPaySettList");
      if(!(pPaySettingsLs.length>0)){
                this.isHideFooter=true;
              }

    } catch (err) {
            let body = Logger.buildRequest(
              COMPONENT_NAME.PAYMENTPAGE,
              "error in getPaySettList",
              err.toString(),
              "getPaySettList",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
     
    }, 
    getSelPaySubDet(pDetails) {
        try {
          if(BaseConfiguration.isDebug) console.log("getSelPaySubDet");
         this.selPaySubDetail= pDetails;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.PAYMENTPAGE,
                  "error in getSelPaySubDet",
                  err.toString(),
                  "getSelPaySubDet",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 
    getDetailsForSelpaySubcard(pSelectedPayRes,pSFlightSearchObj) {
       let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("getDetailsForSelpaySubcard");
          if(pSelectedPayRes.summary&&pSelectedPayRes.summary.pricingSummary&&pSelectedPayRes.summary.pricingSummary[0]){
          retValue={};
                    retValue.total=pSelectedPayRes.summary.pricingSummary[0].Total;
                     retValue.currency=pSFlightSearchObj.currency.currency_code.code;
             
              if(pSFlightSearchObj.trip==2){
               retValue.remarks= pSFlightSearchObj.route[0].from.depcode.airportcode+' - '+pSFlightSearchObj.route[pSFlightSearchObj.route.length-1].from.depcode.airportcode;
              }else{
                retValue.remarks= pSFlightSearchObj.route[0].from.depcode.airportcode+' - '+pSFlightSearchObj.route[pSFlightSearchObj.route.length-1].to.depcode.airportcode;
              }
     
          }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.PAYMENTPAGE,
                  "error in getDetailsForSelpaySubcard",
                  err.toString(),
                  "getDetailsForSelpaySubcard",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 

        async getSelectedPay(pPaymentType) {
          let searchObj;
            try {
              if(BaseConfiguration.isDebug) console.log("getSelectedPay");

             
               this.SET_PAY_TYPE_OBJ(pPaymentType);

               this.selectedPayType.paymentsettingsid = pPaymentType.paymentsettingsid;
        this.selectedPayType.groupId = pPaymentType.groupId;
        this.selectedPayType.providertype=pPaymentType.providertype;
               let retSelectedPayment = await this.getSelectPayment(
          pPaymentType.paymentsettingsid
        );
        // if(retSelectedPayment)
        // {
        //      let selPayDetails= this.getDetailsForSelpaySubcard(retSelectedPayment,this.sHotelSearchObj);
        //      if(selPayDetails){
        //        this.selPayResDetails=selPayDetails;
        //      }
        //     let formattedSelFlight = this.formatCalculatedFee(retSelectedPayment,this.sHotelSearchObj);
        //     if (formattedSelFlight) {
        //     // this.isPayTypeChanged = false;
        //     // setTimeout(() => {
        //     //   this.isPayTypeChanged = true;
        //     // });
        //     this.selFlight = formattedSelFlight;
        //   }
        
        // }
            
       
        
            } catch (err) {
                    let body = Logger.buildRequest(
                       COMPONENT_NAME.PAYMENTPAGE,
                      "error in getSelectedPay",
                      err.toString(),
                      "getSelectedPay",
                      LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                  }
              
            }, 


    getBookFailModalBtns() {
      
      return [
        {
          name: this.$t('paymentPage.okButton'),
          func: this.reloadCurrentPage,
          color: "danger"
        }
      ];
    },
   
   reloadCurrentPage() {
       try {
         if(BaseConfiguration.isDebug) console.log("reloadCurrentPage");
         this.$router.go();
   
       } catch (err) {
               let body = Logger.buildRequest(
                 COMPONENT_NAME.PAYMENTPAGE,
                 "error in reloadCurrentPage",
                 err.toString(),
                 "reloadCurrentPage",
                 LOG_TYPE.ERROR
               );
               Logger.getResponse(body);
             }
       }, 

    ///to navigate flightResult page from alert
    navToResultPage() {
      try {
        if (this.$route.path != PATHNAME.FLIGHTRESULTS) {
          if(this.sSearchObj&&this.sSearchObj.trip!=TRIP.MULTI_CITY){
          navigate(PATHNAME.FLIGHTRESULTS,this.$router.currentRoute.query);
          } else{
            navigate(PATHNAME.ML_FLIGHTRESULTS,this.$router.currentRoute.query);
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAYMENTPAGE,
          "error in navToResultPage",
          err.toString(),
          "navToResultPage",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to show alert,if booking response status error
    onHideSelPaymentAlert() {
      try {
        if (BaseConfiguration.isDebug) console.log("onHideSelPaymentAlert");

        this.isSelPaymentAlert = false;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAYMENTPAGE,
          "error in onHideSelPaymentAlert",
          err.toString(),
          "onHideSelPaymentAlert",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to show alert,if booking response status error
    toggleBookFailAlert() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleBookFailAlert");

        this.isBookFailAlert = !this.isBookFailAlert;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAYMENTPAGE,
          "error in toggleBookFailAlert",
          err.toString(),
          "toggleBookFailAlert",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///show alert to navigate to resultpage
    toggleAlertWhileNav() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleAlertWhileNav");

        this.isAlertWhileNav = !this.isAlertWhileNav;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAYMENTPAGE,
          "error in toggleAlertWhileNav",
          err.toString(),
          "toggleAlertWhileNav",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to assign particular values to query to navigate another domain
    getPayQueryValues(pBookingStatus) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getPayQueryValues");

        let param = {};
        if (pBookingStatus) {
          param[ROUTER_PARAM.SESSION] = this.$router.currentRoute.query[
            ROUTER_PARAM.SESSION_ID
          ];
          param[ROUTER_PARAM.PROVIDER_ID] = pBookingStatus.paymentProviderId;
          param[ROUTER_PARAM.ORDER_PAYMENT_ID] = pBookingStatus.orderPaymentId;
          param[ROUTER_PARAM.TOKEN] = this.sSignInRes.authorization;

          if(BaseConfiguration.paymentDebugUrl!=null) {
            param[ROUTER_PARAM.PAYMENT_DEBUG_URL] = BaseConfiguration.paymentDebugUrl;
          }
          
          retValue = param;
        }else{
          //need to handle
        }
      //if (BaseConfiguration.isDebug)
        //console.error("QUERY STRING",param);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAYMENTPAGE,
          "error in getPayQueryValues",
          err.toString(),
          "getPayQueryValues",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    ///navigate to corresponding pages using proceedTo from booking response
    navByProceedTo(pBookingStatus) {
      
      try {
        if (BaseConfiguration.isDebug) console.log("navByProceedTo");
        
        switch (pBookingStatus.proceedTo) {
          case PROCEED_TO_TYPE.HOLD_PAGE:
            {
              navigate(PATHNAME.HOLDPAGE);
            }
            break;
          case PROCEED_TO_TYPE.FLIGHT_RESULTS_PAGE:
            {
              if (this.alertValue && !pBookingStatus.isBooked) {
                //if booked failed,having error and proceedTo FlightResultPage

                this.toggleAlertWhileNav(); ///show alert and navigate to resultpage
              }
            }
            break;
          case PROCEED_TO_TYPE.PAYMENT_GATEWAY:
            {
              let retQuery = this.getPayQueryValues(pBookingStatus);

              if (retQuery) {
                this.navByHostUrl(PATHNAME.PAYMENTGATEWAY, retQuery,true);
              } else {
                this.reCreatePayBtn();
                throw "Oops,something went wrong!";
              }
            }
            break;
          case PROCEED_TO_TYPE.TICKET_SUCCESS_PAGE:
            {
              navigate(PATHNAME.SUCCESSPAGE);
            }
            break;

          default:
            addClassToBody(COMPONENT_NAME.PAYMENTPAGE);
            this.reCreatePayBtn();
            throw "Invalid Proceed to from createBooking api response! ";
            break;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAYMENTPAGE,
          "error in navByProceedTo",
          err.toString(),
          "navByProceedTo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
     navByHostUrl(pPathName, pQuery,isPaymentPage) {

    try {
        if (pPathName) {
             let origin= BaseConfiguration.isDebug?"https://b2b.ascent24.io":window.location.origin
           
          //let origin= window.location.origin;


            if (pPathName == PATHNAME.PAYMENTGATEWAY) {
                // if(isPaymentPage){

                  // let url = origin + pPathName + "?"  + ROUTER_PARAM.PROVIDER_ID + '=' + pQuery[ROUTER_PARAM.PROVIDER_ID] + '&' 
                  //   + ROUTER_PARAM.ORDER_PAYMENT_ID + '=' + pQuery[ROUTER_PARAM.ORDER_PAYMENT_ID] +
                  //   '&' + ROUTER_PARAM.TOKEN + '=' + pQuery[ROUTER_PARAM.TOKEN] + '&' 
                  //   + ROUTER_PARAM.PAYMENT_DEBUG_URL + '=' + pQuery[ROUTER_PARAM.PAYMENT_DEBUG_URL];
                  let url;
                 if(BaseConfiguration.paymentDebugUrl!=null) {
                  url = origin + pPathName + "?" + ROUTER_PARAM.SESSION + '=' + pQuery[ROUTER_PARAM.SESSION] +
                      '&' + ROUTER_PARAM.PROVIDER_ID + '=' + pQuery[ROUTER_PARAM.PROVIDER_ID] + '&' 
                      + ROUTER_PARAM.ORDER_PAYMENT_ID + '=' + pQuery[ROUTER_PARAM.ORDER_PAYMENT_ID] +
                      '&' + ROUTER_PARAM.TOKEN + '=' + pQuery[ROUTER_PARAM.TOKEN] + '&' 
                      + ROUTER_PARAM.PAYMENT_DEBUG_URL + '=' + pQuery[ROUTER_PARAM.PAYMENT_DEBUG_URL];
                 }else{
                    url = origin + pPathName + "?" + ROUTER_PARAM.SESSION + '=' + pQuery[ROUTER_PARAM.SESSION] +
                      '&' + ROUTER_PARAM.PROVIDER_ID + '=' + pQuery[ROUTER_PARAM.PROVIDER_ID] + '&' 
                      + ROUTER_PARAM.ORDER_PAYMENT_ID + '=' + pQuery[ROUTER_PARAM.ORDER_PAYMENT_ID] +
                      '&' + ROUTER_PARAM.TOKEN + '=' + pQuery[ROUTER_PARAM.TOKEN];
                 }
               

                window.location.assign(url);

            // }else{
            //     window.location.replace(origin + pPathName + "?" +
            //          ROUTER_PARAM.PROVIDER_ID + '=' + pQuery[ROUTER_PARAM.PROVIDER_ID] + '&' + ROUTER_PARAM.ORDER_PAYMENT_ID + '=' + pQuery[ROUTER_PARAM.ORDER_PAYMENT_ID] +
            //         '&' + ROUTER_PARAM.TOKEN + '=' + pQuery[ROUTER_PARAM.TOKEN]);
            // }
        }


        }


    } catch (err) {
        let body = Logger.buildRequest(
            FILE_NAME.PAYMENTPAGE,
            "error in navigateByHostUrl",
            err.toString(),
            "navigateByHostUrl",
            LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
    }
},

    ///to create booking
    async onSubmitPayment() {
      try {
        if (BaseConfiguration.isDebug) console.log("paymentSubmitted");

        if (
          this.selectedPayType.paymentsettingsid &&
          this.selectedPayType.groupId
        ) {
          let selPaySubDetail=cloneData(this.selPaySubDetail);
          let retBookingResponse = await this.createBooking(selPaySubDetail);
          let bookingResponse
          if (retBookingResponse) {
            //  this.CLEAR_RESULT_STORE();
            // this.CLEAR_ML_RESULT_STORE();
            bookingResponse = retBookingResponse;
            
            if(bookingResponse.proceedTo) {
              updateDataEdited(false);
            this.navByProceedTo(bookingResponse);
            }else{
              addClassToBody(COMPONENT_NAME.PAYMENTPAGE);
              this.reCreatePayBtn();
              if(this.alertValue!=null) {
               this.toggleBookFailAlert();
              }
            }

          } 
          else {
            addClassToBody(COMPONENT_NAME.PAYMENTPAGE);
            this.reCreatePayBtn();
            if(this.isNeedToShowAlertModal){
            this.toggleBookFailAlert();            
            }
          }
          
        } else {
          this.reCreatePayBtn();
          this.isSelPaymentAlert = true;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAYMENTPAGE,
          "error in onSubmitPayment",
          err.toString(),
          "onSubmitPayment",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    reCreatePayBtn() {
        try {
          if(BaseConfiguration.isDebug) console.log("reCreatePayBtn");
           this.isPaySubmitted=false;
             let that = this;
    setTimeout(() => {
     that.isPaySubmitted = true;
    },100);
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.PAYMENTPAGE,
                  "error in reCreatePayBtn",
                  err.toString(),
                  "reCreatePayBtn",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 

    //to create booking request
    getCreateBookingReq(pPaxList,pSelPaySubDetail) {
      let retValue = {};
      let pricingReq;

      try {
        if (BaseConfiguration.isDebug) console.log("getCreateBookingReq");
        if(this.searchPricingReq){
          pricingReq=this.searchPricingReq;
        }else if(this.searchMLPricingReq){
          pricingReq=this.searchMLPricingReq
        }

        if (pPaxList && pPaxList.length) {
          let createBookingReq = {};
          
            createBookingReq.agentRef = pPaxList[pPaxList.length-1].bookingRef;
         
          let paxContact = pPaxList.find(pax => {
            return pax.paxType == PAX.CONTACT;
          });

          pPaxList = pPaxList.filter(pax => {
            if (pax && pax.paxType && pax.paxType == PAX.CONTACT) {
              return false;
            } else if (pax && pax.hasOwnProperty("paxType") == false) {
              return false;
            } else {
              return true;
            }
          }); // use obj filter

          let passengerList = [];
          let uniqId=null;
          if (this.$router.currentRoute.query) {
            createBookingReq.sessionId = this.$router.currentRoute.query[
              ROUTER_PARAM.SESSION_ID
            ];
            uniqId = this.$router.currentRoute.query[
              ROUTER_PARAM.ROOM_ID
            ];
          }
          if(pSelPaySubDetail){
         createBookingReq.ref_staffName= pSelPaySubDetail.staffName?pSelPaySubDetail.staffName:null,
         createBookingReq.remarks= pSelPaySubDetail.remarks?pSelPaySubDetail.remarks:null,
         createBookingReq.subAgentId= pSelPaySubDetail.selSubAgent&&pSelPaySubDetail.selSubAgent.id?pSelPaySubDetail.selSubAgent.id:null,
         createBookingReq.paidAmount=pSelPaySubDetail.paidAmount?Number(pSelPaySubDetail.paidAmount):null
          }
       
         
          // createBookingReq.pId = pricingReq.pId;
          //    if (BaseConfiguration.isDebug) console.log(pPaxList);

          pPaxList.forEach((pax, index) => {
            pax = cloneData(pax);
            passengerList.push({
              title: pax.paxTitle.code,
              firstname: pax.fName,
              lastname: pax.lName,
              nationality: pax.nationality.countrycode,
              doctype: pax.idType.code,
              docnumber: pax.idNo,
              docissuer: pax.nationality.countrycode,
              docexpiry: formatDate(pax.expiryDate, DATE_TIME_FORMAT.API_DATE_FORMAT),
              paxdob: formatDate(pax.dob, DATE_TIME_FORMAT.API_DATE_FORMAT),
              mobile_code: null,
              mobile_number: null,
              paxemail: null,
              parentPax: null, //pax.paxType==inf?0:null
              paxtype: pax.paxType,
              gender: pax.gender.code==GENDER.MALE?1:2,
              isleadpax:pax.isLeadPax,
              "uniqCode":uniqId

            });
          });
          if (paxContact) {
            passengerList[0].mobile_code =
              paxContact.mobileCodeObj.calling_code;
            passengerList[0].mobile_number = paxContact.mobileNo;
            passengerList[0].paxemail = paxContact.email;
          } else {
            this.reCreatePayBtn();
            throw "contact details not valid";
          }

          if (
            this.sHotelSearchObj.pax &&
            this.sHotelSearchObj.pax.infantCount &&
            this.sHotelSearchObj.pax.adultCount
          ) {
            //assign parentPax to all infants
            let adultCount =
              cloneData(this.sHotelSearchObj.pax && this.sHotelSearchObj.pax.adultCount) -
              1;

            passengerList.reverse().forEach((pax, index) => {
              if (pax && pax.paxtype == PAX.INFANT) {
                pax.parentPax = adultCount;
                adultCount--;
              }
            });
          }

          createBookingReq.paxList = passengerList.reverse();
          retValue = createBookingReq;
        } else {
          this.reCreatePayBtn();
          throw "failed to Create Booking Request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAYMENTPAGE,
          "error in getCreateBookingReq",
          err.toString(),
          "getCreateBookingReq",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    ///to handling the failed case of booking
    handleBookingFailed(pBookingRes) {
      try {
        if (BaseConfiguration.isDebug) console.log("handleBookingFailed");

        //if status success, but it contains error obj
        let errList = [];
        if (
          pBookingRes.hasOwnProperty("bookingStatus") &&
          pBookingRes.bookingStatus.BookingDetails
        ) {
          for (
            let i = 0;
            i < pBookingRes.bookingStatus.BookingDetails.length;
            i++
          ) {
            if (
              pBookingRes.bookingStatus.BookingDetails[i].hasOwnProperty(
                "error"
              )
            ) {
              if (
                pBookingRes.bookingStatus.BookingDetails[i].error &&
                pBookingRes.bookingStatus.BookingDetails[i].error
                  .constructor === Array
              ) {
                for (
                  let j = 0;
                  j < pBookingRes.bookingStatus.BookingDetails[i].error.length;
                  j++
                ) {
                  errList.push(
                    pBookingRes.bookingStatus.BookingDetails[i].error[j]
                  );
                }
              } else {
                errList.push(pBookingRes.bookingStatus.BookingDetails[i].error);
              }
            } 
//             else {
//               this.alertValue = `Sorry, This booking cant go-through.
// Please try with other flight combination.
// Error code 1805`;
//             }
          }
        }
        this.alertValue = errList;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAYMENTPAGE,
          "error in handleBookingFailed",
          err.toString(),
          "handleBookingFailed",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to get create booking api
    async createBooking(pSelPaySubDetail) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("createBooking");

        let bookingReq = apiCreateBookingForHotel.buildRequest(
          this.getCreateBookingReq(cloneData(this.sPaxList),pSelPaySubDetail)
        );
       
        if (bookingReq) {
          let bookingRes = await apiCreateBookingForHotel.getResponse(bookingReq);
       this.SET_CREATE_BOOKING_REQ(bookingReq);
       

          if (VALIDATE_SUCCESS_RES(bookingRes)) {
            this.SET_CREATE_BOOKING_RES(bookingRes);
      
            if (BaseConfiguration.isDebug) {
              if (
                // to print PNRs in console
                bookingRes &&
                bookingRes.data &&
                bookingRes.data.data &&
                bookingRes.data.data.bookingStatus &&
                bookingRes.data.data.bookingStatus.BookingDetails
              ) {
                for (
                  let t = 0;t < bookingRes.data.data.bookingStatus.BookingDetails.length;
                  t++
                ) {
                  console.log(
                    JSON.stringify(
                      bookingRes.data.data.bookingStatus.BookingDetails[t].pnr
                    )
                  );
                }
              }
            }

            ///if booked is true
            if ( bookingRes && bookingRes.data &&
              bookingRes.data.data &&
              bookingRes.data.data.bookingStatus &&
              bookingRes.data.data.bookingStatus.isBooked
            ) {
              retValue = bookingRes.data.data;
            } ///if booked is false ,but status success
            else {
              retValue = bookingRes.data.data;
              addClassToBody(COMPONENT_NAME.PAYMENTPAGE)
              this.handleBookingFailed(retValue);
            }
          } else {
            //if status error
            retValue = null;
            let error = getErrorMessage(bookingRes);
          
            let isJwt = handleJWT(error);
            if (!isJwt && bookingRes) {
             let isSessionExpired = handleSessionExist(bookingRes.data);
              if(!isSessionExpired){
                addClassToBody(COMPONENT_NAME.PAYMENTPAGE);
              this.alertValue=getErrorAlertValue(error,true,true);

              }else{
                this.isNeedToShowAlertModal=false;
              }
            }else{
              this.isNeedToShowAlertModal=false;
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAYMENTPAGE,
          "error in getting response from create booking API",
          err.toString(),
          "createbooking",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    // //method to call while selecting a payment
    // async onSelectPayment(pPaymentType) {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("onSelectPayment");
    //     this.selectedPayType.paymentsettingsid = pPaymentType.paymentsettingsid;
    //     this.selectedPayType.groupId = pPaymentType.groupid;
    //     this.SET_PAY_TYPE_OBJ(this.selectedPayType);
    //     let retSelectedPayment = await this.getSelectPayment(
    //       pPaymentType.paymentsettingsid
    //     );

    //     if (retSelectedPayment) {
    //       let formattedSelFlight = this.formatCalculatedFee(retSelectedPayment);
    //       if (formattedSelFlight) {
    //         this.isPayTypeChanged = false;
    //         setTimeout(() => {
    //           this.isPayTypeChanged = true;
    //         });
    //         this.selFlight = formattedSelFlight;
    //       }
    //     } else {
    //       throw "failed to create selected payment response ";
    //     }
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.PAYMENTPAGE,
    //       "error in onSelectPayment",
    //       err.toString(),
    //       "onSelectPayment",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },


    //Adding selectStatus, pricegroup_code, Via_Obj, TotalDuration, no_of_days, no_of_stops, no_of_ViaObj
    assigningFlightProp(pflightObj,pCalculatedFees) {
      
      try {
        if (BaseConfiguration.isDebug) console.log("assigningFlightProp");
        if(pCalculatedFees && pCalculatedFees[0]){
          if(pCalculatedFees[0].flight.via){
                 pflightObj.obFlight[0].flight.Via_Obj=pCalculatedFees[0].flight.via.text;
               }else{
                 pflightObj.obFlight[0].flight.Via_Obj=this.$t('flightResults.nonstop');
               }

               
///for no of days
                 pflightObj.obFlight[0].flight.no_of_days =
              getDiffBtwDates(
                new Date(pCalculatedFees[0].flight.ArrDate),
                new Date(pCalculatedFees[0].flight.DepDate),
                
                "days"
              ) != 0
                ? "+" +
                  getDiffBtwDates(
                    new Date(pCalculatedFees[pCalculatedFees.length - 1].flight.ArrDate),
                    new Date(pCalculatedFees[0].flight.DepDate),
                    
                    "days"
                  )
                : null;

///for totalDuration
                for (let j = 0; j <pCalculatedFees.length; j++) {
            
              pflightObj.obFlight[0].flight.TotalDuration +=
              pCalculatedFees[j].flight.DurationInMin;
            if ( pCalculatedFees[j].transit.transittime) {
                 pflightObj.obFlight[0].flight.TotalDuration +=
                 pCalculatedFees[j].transit.transittime;
            }
                }

 

        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ML_FLIGHTRESULTS,
          "error in assigningFlightProp",
          err.toString(),
          "assigningFlightProp",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return pflightObj;
    },


    ///to format pricing from selected payment response
    formatCalculatedFee(pCalculatedFees,pSearchObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("formatCalculatedFee");

        let retValue = cloneDeep(this.selFlight);
        ///if it is multicity
        if(pSearchObj.trip==3){
          if (pCalculatedFees && pCalculatedFees.pUnits.length > 0) {
   let calculatedFees=pCalculatedFees.pUnits;
      for (let i = 0; i < calculatedFees.length; i++) {  
        
        retValue[i] =this.assigningFlightProp(retValue[i],calculatedFees[i].obFlight);
        ///to assign clientPricing 
               if(calculatedFees[i].hasOwnProperty('clientPricing') 
                    &&  calculatedFees.length!=1){
                retValue[i].clientPricing=calculatedFees[i].clientPricing;
               }
 }
 
 if (pCalculatedFees  &&pCalculatedFees.summary&& pCalculatedFees.summary.pricingSummary) {
   for (let i = 0; i < pCalculatedFees.summary.pricingSummary.length; i++) {
   if(pCalculatedFees.summary.pricingSummary.constructor==Array)
       {
               if (pCalculatedFees.summary.pricingSummary[i].hasOwnProperty("isTotal")) {
              retValue[0].clientPricing.TotalTax =
                pCalculatedFees.summary.pricingSummary[i].Tax;
              retValue[0].clientPricing.TotalBaseFare =
                pCalculatedFees.summary.pricingSummary[i].BaseFare;
              retValue[0].clientPricing.TotalAmount =
                pCalculatedFees.summary.pricingSummary[i].Total;
  retValue[0].clientPricing.isTotal= pCalculatedFees.summary.pricingSummary[i].isTotal;
  
            if(retValue.length!=0){
                  for (let i = 1; i < retValue.length; i++) {
                    retValue[i].clientPricing.TotalTax =0;
              retValue[i].clientPricing.TotalBaseFare =0;
              retValue[i].clientPricing.TotalAmount =0;
              retValue[i].clientPricing.isTotal =false;
                    
                  }
                }

            }

            if (
              pCalculatedFees.summary.pricingSummary[i].hasOwnProperty("isPaymentFee")
            ) {
              retValue[0].clientPricing.PaymentTax =
                pCalculatedFees.summary.pricingSummary[i].Tax;
              retValue[0].clientPricing.PaymentBaseFare =
                pCalculatedFees.summary.pricingSummary[i].BaseFare;
              retValue[0].clientPricing.PaymentAmount =
                pCalculatedFees.summary.pricingSummary[i].Total;
 retValue[0].clientPricing.displayText= pCalculatedFees.summary.pricingSummary[i].displayText;
  retValue[0].clientPricing.isPaymentFee= pCalculatedFees.summary.pricingSummary[i].isPaymentFee;

  if(retValue.length!=0){
                  for (let i = 1; i < retValue.length; i++) {
                    retValue[i].clientPricing.PaymentTax =0;
              retValue[i].clientPricing.PaymentBaseFare =0;
              retValue[i].clientPricing.PaymentAmount =0;
              retValue[i].clientPricing.isPaymentFee =false;
                    
                  }
                }

            }
       }
 }
 }
     
      if(pCalculatedFees.pUnits.length>1){
             this.SET_SELFLIGHT_FOR_FOOTER(cloneDeep(retValue));
           }
 }
        }

        ///if it is oneway/ round trip
          else{
            
          
          if(retValue){
        if(retValue.ob&&retValue.ob.clientPricing){
          retValue.ob.clientPricing=null;
           
        }
        if(retValue.ib&&retValue.ib.clientPricing){
         retValue.ib.clientPricing=null;
        }
       
      }
// console.error(this.selFlight);
// console.error(pCalculatedFees);


  if(pCalculatedFees&&pCalculatedFees.pUnits&&pCalculatedFees.pUnits.length>0){///if any cases,(pUnits with length 0 or length 1 or )
           for(let i=0;i<pCalculatedFees.pUnits.length;i++){
              if(pCalculatedFees.pUnits[i].hasOwnProperty(BOUND_TYPE.IB)){//check whether it has ob or not
               retValue.ib.ibFlight = pCalculatedFees.pUnits[i].ibFlight;

               if(pCalculatedFees.pUnits[i].ibFlight[0].flight.via){
                 retValue.ib.ibFlight[0].flight.Via_Obj=pCalculatedFees.pUnits[i].ibFlight[0].flight.via.text;
               }else{
                 retValue.ib.ibFlight[0].flight.Via_Obj=this.$t('flightResults.nonstop');
               }

///no of stops
            retValue.ib.ibFlight[0].flight.no_of_stops ={
              name: null,
              code:null
            }
               retValue.ib.ibFlight[0].flight.no_of_stops.name =
              pCalculatedFees.pUnits[i].ibFlight.length-1 == 0 ? this.$t('flightResults.nonstop') : 
              pCalculatedFees.pUnits[i].ibFlight.length-1 == 1
                ? pCalculatedFees.pUnits[i].ibFlight.length-1 + ' '+this.$t('flightResults.stop')
                : pCalculatedFees.pUnits[i].ibFlight.length-1 > 1 ? pCalculatedFees.pUnits[i].ibFlight.length-1 + ' '+this.$t('flightResults.stops') :null;
         pCalculatedFees.pUnits[i].ibFlight[0].flight.no_of_stops.code =
              pCalculatedFees.pUnits[i].ibFlight.length;
               

///for no of days
                 retValue.ib.ibFlight[0].flight.no_of_days =
              getDiffBtwDates(
                new Date(pCalculatedFees.pUnits[i].ibFlight[0].flight.ArrDate),
                new Date(pCalculatedFees.pUnits[i].ibFlight[0].flight.DepDate),
                
                "days"
              ) != 0
                ? "+" +
                  getDiffBtwDates(
                    new Date(pCalculatedFees.pUnits[i].ibFlight[pCalculatedFees.pUnits[i].ibFlight.length - 1].flight.ArrDate),
                    new Date(pCalculatedFees.pUnits[i].ibFlight[0].flight.DepDate),
                    
                    "days"
                  )
                : null;

///for totalDuration
                for (let j = 0; j <pCalculatedFees.pUnits[i].ibFlight.length; j++) {
            retValue.ib.ibFlight[0].flight.TotalDuration=0;
             retValue.ib.ibFlight[0].flight.TotalDuration +=
              pCalculatedFees.pUnits[i].ibFlight[j].flight.DurationInMin;
            if ( pCalculatedFees.pUnits[i].ibFlight[j].transit.transittime) {
               retValue.ib.ibFlight[0].flight.TotalDuration +=
                 pCalculatedFees.pUnits[i].ibFlight[j].transit.transittime;
            }
                }
 ///to assign clientPricing of ib
               if(pCalculatedFees.pUnits[i].hasOwnProperty('clientPricing')&&pCalculatedFees.pUnits.length!=1){
                retValue.ib.clientPricing=pCalculatedFees.pUnits[i].clientPricing;
                

               }
              }


              if(pCalculatedFees.pUnits[i].hasOwnProperty(BOUND_TYPE.OB)){//check whether it has ib or not
                   retValue.ob.obFlight = pCalculatedFees.pUnits[i].obFlight;
                   if(pCalculatedFees.pUnits[i].obFlight[0].flight.via){
                retValue.ob.obFlight[0].flight.Via_Obj=pCalculatedFees.pUnits[i].obFlight[0].flight.via.text;
               }else{
                retValue.ob.obFlight[0].flight.Via_Obj=this.$t('flightResults.nonstop');
               }

///no of stops
retValue.ob.obFlight[0].flight.no_of_stops ={
              name: null,
              code:null
            }
               retValue.ob.obFlight[0].flight.no_of_stops.name =
              pCalculatedFees.pUnits[i].obFlight.length-1 == 0 ? this.$t('flightResults.nonstop') : 
              pCalculatedFees.pUnits[i].obFlight.length-1 == 1
                ? pCalculatedFees.pUnits[i].obFlight.length-1 + ' '+this.$t('flightResults.stop')
                : pCalculatedFees.pUnits[i].obFlight.length-1 > 1 ? pCalculatedFees.pUnits[i].obFlight.length-1 + ' '+this.$t('flightResults.stops') :null;
         pCalculatedFees.pUnits[i].obFlight[0].flight.no_of_stops.code =
              pCalculatedFees.pUnits[i].obFlight.length;

   ///for no of days
                 retValue.ob.obFlight[0].flight.no_of_days =
              getDiffBtwDates(
                new Date(pCalculatedFees.pUnits[i].obFlight[0].flight.ArrDate),
                new Date(pCalculatedFees.pUnits[i].obFlight[0].flight.DepDate),
                
                "days"
              ) != 0
                ? "+" +
                  getDiffBtwDates(
                    new Date(pCalculatedFees.pUnits[i].obFlight[pCalculatedFees.pUnits[i].obFlight.length - 1].flight.ArrDate),
                    new Date(pCalculatedFees.pUnits[i].obFlight.flight.DepDate),
                    
                    "days"
                  )
                : null;



   ///for totalDuration
                for (let j = 0; j <pCalculatedFees.pUnits[i].obFlight.length; j++) {
            retValue.ob.obFlight[0].flight.TotalDuration=0;
             retValue.ob.obFlight[0].flight.TotalDuration +=
              pCalculatedFees.pUnits[i].obFlight[j].flight.DurationInMin;
            if ( pCalculatedFees.pUnits[i].obFlight[j].transit.transittime) {
               retValue.ob.obFlight[0].flight.TotalDuration +=
                 pCalculatedFees.pUnits[i].obFlight[j].transit.transittime;
            }
                }

                ///to assign clientPricing of ob

                    if(pCalculatedFees.pUnits[i].hasOwnProperty('clientPricing')){
                retValue.ob.clientPricing=pCalculatedFees.pUnits[i].clientPricing;


               }
              }
           }

            if(pCalculatedFees.pUnits.length>1){
             this.SET_SELFLIGHT_FOR_FOOTER(cloneDeep(retValue));
           }
  }
  //  ///assigning the whole clientPricing to OB from summary(because,ib and ob has no property of client pricing)
  //    if( !(pSearchObj.trip==TRIP.ROUND_TRIP?(retValue.ib.hasOwnProperty('clientPricing')&&retValue.ib.clientPricing):true&&(retValue.ob.hasOwnProperty('clientPricing')&&retValue.ob.clientPricing)))
  //    {
  //     if(pCalculatedFees.hasOwnProperty('summary')){
  //     if(pCalculatedFees.summary.hasOwnProperty('pricingSummary'))
  //     {
  //       if(pCalculatedFees.summary.pricingSummary.constructor==Array)//if List
  //       {
  //     retValue.ob.clientPricing.TotalTax =
  //       pCalculatedFees.summary.pricingSummary[0].Tax;
  //     retValue.ob.clientPricing.TotalBaseFare =
  //       pCalculatedFees.summary.pricingSummary[0].BaseFare;
  //     retValue.ob.clientPricing.TotalAmount =
  //       pCalculatedFees.summary.pricingSummary[0].Total;
  //     }else{//if Object
  //       retValue.ob.clientPricing.TotalTax =
  //       pCalculatedFees.summary.pricingSummary.Tax;
  //     retValue.ob.clientPricing.TotalBaseFare =
  //       pCalculatedFees.summary.pricingSummary.BaseFare;
  //     retValue.ob.clientPricing.TotalAmount =
  //       pCalculatedFees.summary.pricingSummary.Total;
  //     }
  //     }

  //           //to assign currency
  //     if(pSelectedPricing.hasOwnProperty('currency')){
  //       if(pSelectedPricing.currency.code)
  //       {
  //        retValue.ob.clientPricing.Currency = pSelectedPricing.currency.code;
  //       }
  //     }
  //             ///to assign adult Price
  //     if (pSearchObj.pax.adultCount > 0) {
  //       if(pSelectedPricing.summary.hasOwnProperty('AdultTotal'))
  //       {
  //       retValue.ob.clientPricing.AdultPrice =
  //         pSelectedPricing.summary.AdultTotal;
  //       }
  //     } else {
  //       retValue.ob.clientPricing.AdultPrice = null;
  //     }

  //         ///to assign child price
  //     if (pSearchObj.pax.childCount > 0) {
  //        if(pSelectedPricing.summary.hasOwnProperty('ChildTotal'))
  //       {
  //       retValue.ob.clientPricing.ChildPrice =
  //         pSelectedPricing.summary.ChildTotal;
  //       }
  //     } else {
  //       retValue.ob.clientPricing.ChildPrice = null;
  //     }
  //     ///to assign infant price
  //     if (pSearchObj.pax.infantCount > 0) {
  //         if(pSelectedPricing.summary.hasOwnProperty('InfantTotal'))
  //       {
  //       retValue.ob.clientPricing.InfantPrice =
  //         pSelectedPricing.summary.InfantTotal;
  //       }
  //     } else {
  //       retValue.ob.clientPricing.InfantPrice = null;
  //     }

  //           //assigning null to ib,because we have assigned whole summary to ob(ob-(common) will come from both OneWay and TwoWay)
  //       if( retValue.ib){
  //          retValue.ib.clientPricing=null;
  //       }

  //    }

  //  }

///
        if (pCalculatedFees  &&pCalculatedFees.summary&& pCalculatedFees.summary.pricingSummary) {
       if(pCalculatedFees.summary.pricingSummary.constructor==Array)
       {
          for (let i = 0; i < pCalculatedFees.summary.pricingSummary.length; i++) {
            if (pCalculatedFees.summary.pricingSummary[i].hasOwnProperty("isTotal")) {
              retValue.ob.clientPricing.TotalTax =
                pCalculatedFees.summary.pricingSummary[i].Tax;
              retValue.ob.clientPricing.TotalBaseFare =
                pCalculatedFees.summary.pricingSummary[i].BaseFare;
              retValue.ob.clientPricing.TotalAmount =
                pCalculatedFees.summary.pricingSummary[i].Total;
  retValue.ob.clientPricing.isTotal= pCalculatedFees.summary.pricingSummary[i].isTotal;

                if(retValue.ib&&retValue.ib.clientPricing)
        {
       retValue.ib.clientPricing.TotalTax =0;
      retValue.ib.clientPricing.TotalBaseFare =0;
       
      retValue.ib.clientPricing.TotalAmount =0;
      retValue.ib.clientPricing.isTotal=false;
        }
            }

            if (
              pCalculatedFees.summary.pricingSummary[i].hasOwnProperty("isPaymentFee")
            ) {
              retValue.ob.clientPricing.PaymentTax =
                pCalculatedFees.summary.pricingSummary[i].Tax;
              retValue.ob.clientPricing.PaymentBaseFare =
                pCalculatedFees.summary.pricingSummary[i].BaseFare;
              retValue.ob.clientPricing.PaymentAmount =
                pCalculatedFees.summary.pricingSummary[i].Total;
 retValue.ob.clientPricing.displayText= pCalculatedFees.summary.pricingSummary[i].displayText;
  retValue.ob.clientPricing.isPaymentFee= pCalculatedFees.summary.pricingSummary[i].isPaymentFee;

                if(retValue.ib&&retValue.ib.clientPricing)
        {
       retValue.ib.clientPricing.PaymentTax =0;
      retValue.ib.clientPricing.PaymentBaseFare =0;
       
      retValue.ib.clientPricing.PaymentAmount =0;
      retValue.ib.clientPricing.isPaymentFee=false;
        }
            }
          }
       }

        }
 if(!(pCalculatedFees.pUnits.length>1)){
             this.SET_SELFLIGHT_FOR_FOOTER(cloneDeep(retValue));
           }
        // if (pCalculatedFees.AdultTotal) {
        //   retValue.ob.clientPricing.AdultPrice = pCalculatedFees.AdultTotal;
        // }
        // if (pCalculatedFees.ChildTotal) {
        //   retValue.ob.clientPricing.ChildPrice = pCalculatedFees.ChildTotal;
        // }
        // if (pCalculatedFees.InfantTotal) {
        //   retValue.ob.clientPricing.InfantPrice = pCalculatedFees.InfantTotal;
        // }

        // if (retValue.ib) {
        //   retValue.ib.clientPricing = null;
        // }
          }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAYMENTPAGE,
          "error in formatCalculatedFee",
          err.toString(),
          "formatCalculatedFee",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async getSelectPayment(pPaymentsettingsid) {
      try {
        let retValue;
        if (BaseConfiguration.isDebug) console.log("getSelectPayment");
        let selectPayRequest = apiSelectPaymentForHotel.buildRequest(
          this.$router.currentRoute.query[ROUTER_PARAM.SESSION_ID],
          pPaymentsettingsid
        );

        if (selectPayRequest) {
          let selectPayResponse = await apiSelectPaymentForHotel.getResponse(
            selectPayRequest
          );
        

          if (VALIDATE_SUCCESS_RES(selectPayResponse)) {//VALIDATE_SUCCESS_RES(selectPayResponse)
            retValue = selectPayResponse.data.data;
          } else {
            let error = getErrorMessage(selectPayResponse);
            // if (retSessionVal) {
            //   this.showToast(retSessionVal, TOAST_TYPE.ERROR, 5000, null);
            // }
            let isJwt = handleJWT(error);
            if (!isJwt && selectPayResponse) {
              
                let isSessionExpired = handleSessionExist(selectPayResponse.data);
             if(!isSessionExpired)
             {
              this.alertValue = getErrorAlertValue(error);

             }
            }
          }
        } else {
          this.reCreatePayBtn();
          throw "invalid select payment request";
        }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAYMENTPAGE,
          "error in getSelectPayment",
          err.toString(),
          "getSelectPayment",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    // async getPaySettingsRes() {
    //   try {
    //     let retValue;
    //     if (BaseConfiguration.isDebug) console.log("getPaySettingsRes");
    //     let paySettingsRequest = apiGetPaymentSettings.buildRequest(
    //       this.$router.currentRoute.query[ROUTER_PARAM.SESSION_ID]
    //     );

    //     if (paySettingsRequest) {
    //       let paySettingsResponse = await apiGetPaymentSettings.getResponse(
    //         paySettingsRequest
    //       );

    //       if (VALIDATE_SUCCESS_RES(paySettingsResponse)) {
    //         retValue = paySettingsResponse.data.data;
    //       } else {
    //         let error = getErrorMessage(paySettingsResponse);
    //         let isSessionExpired = handleSessionExist(paySettingsResponse.data);
    //         // if (retSessionVal) {
    //         //   this.showToast(retSessionVal, TOAST_TYPE.ERROR, 5000, null);
    //         // }
    //         let isJwt = handleJWT(error);
    //         if (!isJwt) {
    //           this.alertValue = getErrorAlertValue(error);
    //         }
    //       }
    //     } else {
    //       throw "Failed to create payment settings request.";
    //     }
    //     return retValue;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.PAYMENTPAGE,
    //       "error in getPaySettingsRes",
    //       err.toString(),
    //       "getPaySettingsRes",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },

    ///to show or hide terms&conditions modal
    onToggleTCModal() {
      try {
        this.isTCshow = !this.isTCshow;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PAYMENTPAGE,
          "error while showing modal",
          err.toString(),
          "onToggleTCModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }

    ///to get selected payment
    // getSelectedPay(pPayment) {
    //   try {
    //     this.selectedPayment = pPayment;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.PAYMENTPAGE,
    //       "error while getting selected pay",
    //       err.toString(),
    //       "getSelectedPay",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // }

    ///to get payment logo image
    // getPaylogoImg(pCode) {
    //     try {
    //         let path = BaseConfiguration.payImagePath;
      //         var images = require.context(
      //             "../../../../assets/mf/img/payment_logo/",
      //             false,
      //             /\.png$/
      //         );
      //         return images("./" + pCode.toLowerCase() + ".png");
    //     } catch (err) {
    //         let body = Logger.buildRequest(
    //             COMPONENT_NAME.PAYMENTPAGE,
    //             "error while getting image",
    //             err.toString(),
    //             " getPaylogoImg",
    //             LOG_TYPE.ERROR
    //         );
    //         Logger.getResponse(body);
    //     }
    // }
  },

  beforeCreate() {
    addClassToBody(COMPONENT_NAME.PAYMENTPAGE);
  },

  beforeDestroy() {
             this.$root.$emit("toggle-sidebar-minimize", true);

    removeClassBody();
  }
};
</script>
<style>
</style>